import React from 'react';
// Facebook, Instagram, Linkedin, Youtube: reativar quando as redes sociais voltarem.
import { Send } from 'lucide-react';
import { Link } from 'react-router-dom';

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="text-xs font-bold uppercase tracking-widest text-white/50 mb-4">{title}</h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.label}>
          <Link to={l.to} className="text-sm text-white/80 hover:text-[#FF5B24] transition-colors">
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

const Footer = () => (
  <footer className="bg-[#050818] pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-[1.5fr_1fr_1fr_1fr_1fr] gap-10 pb-14 border-b border-white/10">
        <div>
          <Link to="/" className="flex items-center">
            <img src="/logo-white.png" alt="CoreDesk" width="148" height="36" className="h-9 w-auto" />
          </Link>
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-sm">
            Plataforma completa de atendimento e vendas com IA. Centralize conversas, automatize processos e resolva chamados em uma única solução.
          </p>
          <div className="mt-6">
            <div className="text-xs font-semibold text-white/70 mb-3">Receba novidades no seu e-mail</div>
            <form className="flex items-center gap-2 max-w-sm" onSubmit={(e) => { e.preventDefault(); e.target.reset(); }}>
              <input
                type="email"
                required
                placeholder="seu@email.com"
                className="flex-1 h-11 px-4 bg-white/5 border border-white/10 rounded-full text-sm text-white placeholder:text-white/40 focus:outline-none focus:border-[#FF5B24]"
              />
              <button type="submit" className="h-11 w-11 rounded-full btn-coral flex items-center justify-center" aria-label="Inscrever">
                <Send size={16} />
              </button>
            </form>
          </div>
        </div>
        <FooterCol title="Produtos" links={[
          { label: 'Atendimento e Chatbot', to: '/produtos#conversas' },
          { label: 'Central de Suporte', to: '/produtos#helpdesk' },
          { label: 'Agentes de IA', to: '/produtos#coreai' },
          { label: 'Integrações', to: '/integracoes' },
          { label: 'Preços', to: '/precos' },
        ]} />
        <FooterCol title="Recursos" links={[
          { label: 'Blog', to: '/blog' },
          { label: 'Central de Ajuda', to: '/ajuda' },
          { label: 'Calculadora de ROI', to: '/calculadora-roi' },
          { label: 'API & Desenvolvedores', to: '/desenvolvedores' },
        ]} />
        <FooterCol title="Empresa" links={[
          { label: 'Sobre a CoreDesk', to: '/sobre' },
          { label: 'Fale conosco', to: '/contato' },
        ]} />
        <FooterCol title="Legal" links={[
          { label: 'Termos de uso', to: '/termos' },
          { label: 'Política de Privacidade', to: '/privacidade' },
          { label: 'LGPD', to: '/privacidade' },
        ]} />
      </div>

      <div className="pt-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="text-xs text-white/50">
          © {new Date().getFullYear()} CoreDesk · Todos os direitos reservados
        </div>
        {/* Redes sociais removidas por enquanto — reativar no futuro.
        <div className="flex items-center gap-2">
          {[
            { Icon: Facebook, label: 'Facebook' },
            { Icon: Instagram, label: 'Instagram' },
            { Icon: Linkedin, label: 'LinkedIn' },
            { Icon: Youtube, label: 'YouTube' },
          ].map(({ Icon, label }) => (
            <a key={label} href="#" aria-label={label} className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#FF5B24] flex items-center justify-center transition-colors">
              <Icon size={16} className="text-white" />
            </a>
          ))}
        </div>
        */}
      </div>
    </div>
  </footer>
);

export default Footer;
